import { Component, Input, OnChanges, OnDestroy, SimpleChanges, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiEmptyImageComponent } from './ui-empty-image.component';

@Component({
    selector: 'app-product-image-carousel',
    standalone: true,
    imports: [CommonModule, UiEmptyImageComponent],
    template: `
    <div class="relative w-full h-full overflow-hidden bg-gray-50"
      (mouseenter)="onEnter()" (mouseleave)="onLeave()">
      <app-ui-empty-image *ngIf="visibles().length === 0" iconClass="w-12 h-12"></app-ui-empty-image>

      <img
        *ngFor="let url of visibles(); let i = index"
        [src]="url"
        [alt]="alt"
        (error)="fallar(url)"
        loading="lazy" decoding="async"
        class="absolute inset-0 w-full h-full object-cover object-center transition-opacity duration-700 ease-in-out"
        [class.opacity-100]="i === activo()"
        [class.opacity-0]="i !== activo()"
      />

      <div *ngIf="visibles().length > 1" class="absolute bottom-2.5 left-1/2 -translate-x-1/2 flex items-center gap-1.5 z-10">
        <span *ngFor="let url of visibles(); let i = index"
          class="h-1.5 rounded-full bg-white shadow-sm transition-all duration-300"
          [class.w-4]="i === activo()"
          [class.w-1.5]="i !== activo()"
          [class.opacity-100]="i === activo()"
          [class.opacity-60]="i !== activo()"></span>
      </div>
    </div>
    `
})
export class ProductImageCarouselComponent implements OnChanges, OnDestroy {
    @Input({ required: true }) images: string[] = [];
    @Input() alt = '';
    @Input() intervaloMs = 900;

    activo = signal(0);
    visibles = signal<string[]>([]);

    private timer: ReturnType<typeof setInterval> | null = null;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['images']) {
            this.visibles.set((this.images ?? []).filter((url) => !!url));
            this.activo.set(0);
            this.detener();
        }
    }

    ngOnDestroy() {
        this.detener();
    }

    onEnter() {
        if (this.visibles().length < 2 || this.timer) {
            return;
        }
        this.timer = setInterval(() => {
            this.activo.update((i) => (i + 1) % this.visibles().length);
        }, this.intervaloMs);
    }

    onLeave() {
        this.detener();
        this.activo.set(0);
    }

    fallar(url: string) {
        const restantes = this.visibles().filter((u) => u !== url);
        this.visibles.set(restantes);
        if (this.activo() >= restantes.length) {
            this.activo.set(0);
        }
        if (restantes.length < 2) {
            this.detener();
        }
    }

    private detener() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }
}
